import React from "react";
import Storage from "../../services/storage.service";
import Flow from "../../services/flow.service";

const CartButton = () => {

    const [isCart, setIsCart] = React.useState(false);
    const [isCartVisible, setIsCartVisible] = React.useState(false);

    React.useEffect(() => {

        const subscriptions = [];

        subscriptions.push(
            Storage.get_obsrv("flow_status_flags").subscribe(flowStatusFlags => {
                if (!flowStatusFlags)
                    return;

                const {is_plan_selected, is_number_selected} = flowStatusFlags;

                if (is_plan_selected || is_number_selected) {
                    setIsCart(true);
                } else {
                    setIsCart(false);
                }

            })
        );

        subscriptions.push(
            Flow.get_route().subscribe(routeTo => {
                setIsCartVisible(Flow.pathNumberOf(routeTo) < Flow.stepNumberOf("payment"));
            })
        );

        return function cleanup() {
            // unmount remove subscribe
            if (subscriptions)
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
        };
    }, []);

    const openSidebar = () => {
        Storage.set("summary_modal", true);
    };

    let count = isCart? <div className="vmo-brand-cart-count" />: "";

    if(!isCartVisible){
        return "";
    }

    return (
        <div className="vmo-brand-cart-trigger" onClick={()=>{if(isCart){openSidebar();}}}>{count}</div>
    );
};

export default CartButton;
